import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../core/reducer/pharmacySlice";
import {
    typologyHoursName, typeHoursInitArray,
} from "../../common/typeHours";
import BtnPrimary from "../../shared/ui/button/primary/BtnPrimary";

export function ContextMenuCalendar({contextMenu, closeContextMenu, changeEventData, deleteEvent}: {
    contextMenu: any,
    deleteEvent: (id: any) => void,
    changeEventData: (data: any, event: any) => void,
    closeContextMenu: () => void
}) {
    const selectedPharmacy = useSelector(selectSelectedPharmacy);
    const isTimeBank = selectedPharmacy?.timeBank;

    const hoursType: any = {
        work: typeHoursInitArray.filter(ele => ele.typology === typologyHoursName.work),
        notWork: typeHoursInitArray.filter((ele: any) => (ele.timeBank === undefined || ele.timeBank === isTimeBank) && ele.typology === typologyHoursName.notWork)
    }
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            const menu = document.getElementById('context-menu');
            if (menu && !menu.contains(event.target)) {
                closeContextMenu();
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [contextMenu]);

    const [typeHours, setTypeHours] = useState(typologyHoursName.work);
    const changeTypeHour = (data: any) => {
        changeEventData(data, contextMenu)
    }
    return (

        <div
            id="context-menu"
            className="calendar-context-menu"
            style={{
                position: 'absolute',
                top: contextMenu.y - 250,
                left: contextMenu.x - 400,
                zIndex: 1000,
            }}
        >
            <div className={'menu-content'}>
                <span className={'title-menu'}>Segna tipo ore come:</span>
                <ul className={'nav nav-pills nav-fill'}>
                    <li className={'nav-item'} onClick={() => setTypeHours(typologyHoursName.work)}>
                        <a className={`nav-link ${typeHours === typologyHoursName.work ? 'active' : ''}`}
                           aria-current="page"
                           href="#">Lavoro</a>
                    </li>
                    <li className={'nav-item'} onClick={() => setTypeHours(typologyHoursName.notWork)}>
                        <a className={`nav-link ${typeHours === typologyHoursName.notWork ? 'active' : ''}`}
                           aria-current="page"
                           href="#">Non lavoro</a>
                    </li>
                </ul>
                <ul className={'menu-voice'}>
                    {hoursType[typeHours]?.map((v: any, k: number) =>
                        <li key={k} onClick={() => changeTypeHour(v)}>
                            {v.label}
                        </li>)}
                </ul>
                <div className={'d-flex justify-content-end px-2 border-top pt-2 mt-2'}>
                    <BtnPrimary title="Resetta" icon={'./assets/icons/delete.svg'}
                                variant={'outline-primary'} className={'text-red-500 border-red-500'}
                                onClick={() => deleteEvent(contextMenu.event)}></BtnPrimary>
                </div>
            </div>
        </div>
    );
}


